import styled from "styled-components";

import { colorsPalettes, setElevation, setFontVariant } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

const { carbon } = colorsPalettes;

export const Container = styled(Stack)`
    gap: 16px;
    width: 100%;

    animation: fade-in 250ms ease-in-out;

    @keyframes fade-in {
        from {
            opacity: 0;
            transform: translateY(8px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

export const RecentsContainer = styled(Flex)`
    width: 100%;

    gap: 16px;

    padding: 16px;
    border-radius: 6px;
    background: ${carbon[0]};

    ${setElevation("Z1")};
`;

export const Item = styled(Flex)`
    width: 33.3%;
    min-height: 48px;

    gap: 8px;
    padding: 8px;
    border: 1px solid ${carbon[50]};
    border-radius: 6px;
    background: ${carbon[0]};
    transition: box-shadow 0.2s ease;
    cursor: pointer;

    &:hover {
        ${setElevation("Z1")};
    }
`;

export const IconContainer = styled.div<{ hasOneIcon: boolean }>`
    position: relative;
    width: 32px;

    div {
        top: 10px;
        left: 20px;
    }

    .ItemIcon {
        position: absolute;
        width: 20px;
        height: 20px;
        margin: 0;
        top: 10px;
        left: 10px;

        &:first-child {
            top: 0;
            left: 0;

            ${({ hasOneIcon }) => hasOneIcon && `width: 32px; height: 32px;`};
        }
    }
`;

export const InfoContainer = styled(Stack)`
    gap: 2px;
`;

export const CompetitorsContainer = styled(Flex)`
    gap: 8px;
    ${setFontVariant("body2", carbon[300])};
`;

export const KeywordIconContainer = styled(Flex)`
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    border: 1px solid ${carbon[50]};
`;
